import logo from "../img/logo PLA.png";
import workingOn from "../assets/working.svg"


function Home() {

    return (
        <div className="Main Container">
            <head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet" />

            </head>
            <body class="flex flex-col min-h-screen">
                <header className="flex items-center justify-between px-10 py-4 bg-white border-b">
                    
                    <nav className="flex-1">
                        <ul className="flex justify-evenly w-full6">
                            <li><a href="/" className="text-xl">Quienes Somos</a></li>
                            <li><a href="/" className="text-xl">Nuestros Proyectos</a></li>                  
                        </ul>
                    </nav>

                    <div className="flex-shrink-0">
                        <img src={logo} alt="Logo" className="h-40"></img>
                    </div>

                    <nav className="flex flex-1">
                        <ul className="flex justify-evenly w-full">
                            <li><a href="/" className="text-xl">Contacto</a></li>
                            <li><button className="text-xl">Asociate</button></li>                  
                        </ul>
                    </nav>


                </header>
                <main>
                    <div className="flex flex-col items-center justify-center text-center mt-6">
                        <img src={workingOn} alt="working on" className="h-80" />
                        <h2 className="text-3xl font-semibold">Proximamente!</h2>
                    </div>
                </main>

                <footer className="footer mt-auto flex items-center justify-center h-36 relative overflow-visible clip-path-custom">
                    <label className="pt-16 text-white font-semibold text-center font-poppins text-3xl italic tracking-wider">www.pintalaaldea.org.ar</label>

                </footer>

            </body>
        </div>
    )

}

export default Home;